import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import BASEURL from "../../BaseUrl";


const createMasterThunk = (name, endpoint) => {
  return {
    fetch: createAsyncThunk(`masterData/fetch${name}`, async (_, thunkAPI) => {
      try {
        const res = await axios.get(`${BASEURL}/api/get-${endpoint}`);
        return res.data;
      } catch (err) {
        return thunkAPI.rejectWithValue(
          err.response?.data?.message || `Failed to fetch ${name}`
        );
      }
    }),
  };
};

export const designationAPI = createMasterThunk("Designation", "designation");
export const nationalityAPI = createMasterThunk("Nationality", "nationality");
export const departmentAPI = createMasterThunk("Department", "department");
export const employeeStatusAPI = createMasterThunk("EmployeeStatus", "employee-status");
export const employmentTypeAPI = createMasterThunk("EmploymentType", "employment-type");
export const workLocationAPI = createMasterThunk("WorkLocation", "work-location");